import React, { useEffect, useState } from "react";
import { BarChart } from '@mui/x-charts/BarChart';
import { fetchActivityReport } from "../../resources/DashboardResource";

const ruData = [];
const iData = [];
const rData = [];
const tData = [];
const mData = [];
const xLabels = [];

export default function ActivityReport() {
  const [dataActivityReport, setDataActivityReport] = useState(null);

  const fetchDataActivityReport = () => {
    fetchActivityReport()
      .then((res) => {

        res.data.forEach(element => {
          xLabels.push(element.o_month === 1 ? "JAN"
            : element.o_month === 2 ? "FEB"
              : element.o_month === 3 ? "MAR"
                : element.o_month === 4 ? "APR"
                  : element.o_month === 5 ? "MEI"
                    : element.o_month === 6 ? "JUN"
                      : element.o_month === 7 ? "JUL"
                        : element.o_month === 8 ? "AUG"
                          : element.o_month === 9 ? "SEP"
                            : element.o_month === 10 ? "OCT"
                              : element.o_month === 11 ? "NOV" : "DEC");
          element.data.forEach(dataDetail => {
            if (dataDetail.purpose === "Routine Usage") {
              ruData.push(dataDetail.used === null ? 0 : dataDetail.used);
            }
            if (dataDetail.purpose === "Investment") {
              iData.push(dataDetail.used === null ? 0 : dataDetail.used);
            }
            if (dataDetail.purpose === "Repair") {
              rData.push(dataDetail.used === null ? 0 : dataDetail.used);
            }
            if (dataDetail.purpose === "Trial/Event Kaizen") {
              tData.push(dataDetail.used === null ? 0 : dataDetail.used);
            }
            if (dataDetail.purpose === "Missing Part") {
              mData.push(dataDetail.used === null ? 0 : dataDetail.used);
            }
          })
        });

        setDataActivityReport(res.data);
      })
      .catch((err) => {
        setDataActivityReport([]);
      });
  };

  useEffect(() => {
    fetchDataActivityReport();
  }, []);

  return (
    <div>
      {!dataActivityReport ? <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '260px'
      }}>
        <div className="spinner-border text-primary" role="status"> <span className="visually-hidden">Loading...</span>
        </div>
      </div> : dataActivityReport.length === 0 ? <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '260px'
      }}>
        <div><span>Data is Empty</span></div>
      </div> : <BarChart
        width={700}
        height={300}
        series={[
          { data: ruData, label: 'Routine Usage', id: 'ruId', stack: 'total' },
          { data: iData, label: 'Investment', id: 'iId', stack: 'total' },
          { data: rData, label: 'Repair', id: 'rId', stack: 'total' },
          { data: tData, label: 'Trial/ Event Kaizen', id: 'tId', stack: 'total' },
          { data: mData, label: 'Missing Part', id: 'mId', stack: 'total' },
        ]}
        xAxis={[{ data: xLabels, scaleType: 'band' }]}
        colors={["#702DFF", "#9B93FD", "#C6C8FD", "#E5E6FC", "#DD3545"]}
      />}
    </div>
  );
}